import React from 'react';
import styles from './privacy.module.css';

const Privacy = () => {
  return (
    <main className={styles.main}>
      <section className={styles.section}>
        <h1>Privacyverklaring</h1>
        <p>
            vzw K.F. "De Moedige Vrienden" Borgt - Grimbergen hecht veel waarde aan de bescherming van uw persoonsgegevens (en dat uw privacy wordt gerespecteerd).
        </p>
        <p>
            In deze privacyverklaring willen we heldere en transparante informatie geven over (welke gegevens we verzamelen) hoe wij omgaan met persoonsgegevens.
            Wij doen er alles aan om uw privacy te waarborgen en gaan daarom zorgvuldig om met persoonsgegevens.
            K.F. "De Moedige Vrienden" houdt zich in alle gevallen aan de toepasselijke wet- en regelgeving, waaronder de Algemene Verordening Gegevensbescherming.
        </p>
        <p>
            Dit brengt met zich mee dat wij in ieder geval:
        </p>
        <ul>
            <li>
            uw persoonsgegevens verwerken in overeenstemming met het doel waarvoor deze zijn verstrekt, deze doelen en type persoonsgegevens zijn beschreven in deze Privacy verklaring;
            </li>
            <li>
            verwerking van uw persoonsgegevens beperkt is tot enkel die gegevens welke minimaal nodig zijn voor de doeleinden waarvoor ze worden verwerkt;
            </li>
            <li>
            vragen om uw uitdrukkelijke toestemming als wij deze nodig hebben voor de verwerking van uw persoonsgegevens;
            </li>
            <li>
            passende technische en organisatorische maatregelen hebben genomen zodat de beveiliging van uw persoonsgegevens gewaarborgd is;
            </li>
            <li>
            geen persoonsgegevens doorgeven aan andere partijen, tenzij dit nodig is voor uitvoering van de doeleinden waarvoor ze zijn verstrekt;
            </li>
            <li>
            op de hoogte zijn van uw rechten omtrent uw persoonsgegevens, u hierop willen wijzen en deze respecteren.
            </li>
        </ul>
        <p>
            Als fanfare zijn wij verantwoordelijk voor de verwerking van uw persoonsgegevens. Indien u na het doornemen van onze privacy verklaring, of in algemenere zin, vragen heeft hierover of contact met ons wenst op te nemen kan dit via onderstaande contactgegevens:
        </p>


        <ul className={styles.geen_opmaak}>
          <li>K.F. "De Moedige Vrienden"</li>
          <li>Albrecht Rodenbachlaan 46/3</li>
          <li>1850 Grimbergen</li>
          <li><a className={styles.fanfareLink} href="mailto: k.f.demoedigevrienden@gmail.com">k.f.demoedigevrienden@gmail.com</a></li>
        </ul>
      </section>

      <section>
        <h3>
        Waarom verwerken wij persoonsgegevens?
        </h3>
        <p>
        Uw persoonsgegevens worden door vzw K.F. "De Moedige Vrienden" verwerkt ten behoeve van de volgende doeleinden en rechtsgronden :
        </p>
        <ul>
        <li>
            om te kunnen deelnemen aan de activiteiten van fanfare;
        </li>
        <li>
            Het versturen van nieuwsbrieven en uitnodigingen.
        </li>
        <li>
            Het bekomen van subsidiëring door de overheid <br></br>
            Voor de bovenstaande doelstellingen kunnen wij de volgende persoonsgegevens van u vragen en opslagen :
            <ul>
            <li>
                Persoonlijke identiteitsgegevens : naam, voornaam, adres, telefoonnummer, e-mail, geboortedatum :
            </li>
            <li>
                Identiteitsgegevens uitgegeven door overheid : identiteitskaartnummer, rijksregisternummer (bestuursleden)
            </li>
            <li>
                Persoonlijke kenmerken: aansluiting bij de fanfare, bespelende instrumenten
            </li>
            </ul>
        </li>
        </ul>
        <p>We gebruiken de verzamelde gegevens alleen voor de doeleinden waarvoor we de gegevens hebben verkregen.</p>
    </section>

    <section>
        <h3>Verstrekking aan derden</h3>
        <p>
        De gegevens die u aan ons geeft kunnen wij aan derde partijen verstrekken indien dit noodzakelijk is voor uitvoering van de hierboven beschreven doeleinden.
        </p>
        <p>Zo maken wij gebruik van een derde partij voor:</p>
        <ul>
        <li>
            het verzorgen van de internet omgeving (webhosting);
        </li>
        <li>
            het verzorgen (en verspreiden) van nieuwsbrieven en uitnodigingen.
        </li>
        <li>
            Wij geven nooit persoonsgegevens door aan andere partijen waarmee we geen verwerkersovereenkomst hebben afgesloten.
        </li>
        </ul>
        <p>
        Met deze partijen (verwerkers) maken wij hierin uiteraard de nodige afspraken om de beveiliging van uw persoonsgegevens te waarborgen.
        </p>
        <p>
        Verder zullen wij de door u verstrekte gegevens niet aan derden doorgeven, tenzij dit wettelijk verplicht en toegestaan is.
        Een voorbeeld hiervan is dat de politie in het kader van een onderzoek  (persoons)gegevens bij ons opvraagt.
        In een dergelijk geval dienen wij medewerking te verlenen en zijn dan ook verplicht deze gegevens af te geven.
        </p>
        <p>
        Tevens kunnen wij persoonsgegevens delen met derden indien u ons hier (schriftelijk) toestemming voor geeft.
        U heeft het recht deze toestemming ten allen tijde in te trekken, zonder dat dit afbreuk doet aan de rechtmatigheid van de verwerking voor de intrekking daarvan.
        Wij verstrekken geen persoonsgegevens aan partijen welke gevestigd zijn buiten de EU.
        </p>
    </section>

    <section>
        <h3>Minderjarigen</h3>
        <p>
        Wij verwerken enkel en alleen persoonsgegevens van minderjarigen (personen jonger dan 16 jaar) indien daarvoor schriftelijke toestemming is gegeven door de ouder of wettelijke vertegenwoordiger.
        </p>
    </section>

    <section>
        <h3>Bewaartermijn</h3>
        <p>
        K.F. "De Moedige Vrienden" bewaart persoonsgegevens niet langer dan twee jaar na het verlaten van de fanfare, noodzakelijk voor het doel waarvoor deze zijn verstrekt dan wel op grond van de wet is vereist.
        Er wordt wel je naam en de jaren dat je actief bij onze vereniging was, bewaard voor archivering.
        </p>
    </section>

    <section>
        <h3>Beveiliging van de gegevens</h3>
        <p>
        Wij hebben passende technische en organisatorische maatregelen genomen om persoonsgegevens van u te beschermen tegen onrechtmatige verwerking, zo hebben we bijvoorbeeld de volgende maatregelen genomen:
        </p>
        <ul>
        <li>
            Alle personen die namens de fanfare van uw gegevens kennis kunnen nemen, zijn gehouden aan geheimhouding daarvan.
        </li>
        <li>
            Wij maken back-ups van de persoonsgegevens om deze te kunnen herstellen bij fysieke of technische incidenten;
        </li>
        <li>
            Onze medewerkers zijn geïnformeerd over het belang van de bescherming van persoonsgegevens.
        </li>
        </ul>
    </section>

    <section>
        <h3>Uw rechten omtrent uw gegevens</h3>
        <p>
        U heeft recht op inzage en recht op correctie of verwijdering van de persoonsgegeven welke wij van u ontvangen hebben.
        Bovenaan dit privacy statement staat hoe je contact met ons kan opnemen.
        (U kan ons ook contacteren via de contactpagina van onze website <a href="#">www.kfdemoedigevrienden.be</a> ).
        </p>
        <p>
        Tevens kunt u bezwaar (verzet) maken tegen de verwerking van uw persoonsgegevens (of een deel hiervan) door ons of door één van onze verwerkers.
        </p>
        <p>
        Ook heeft u het recht om de door u verstrekte gegevens door ons te laten overdragen aan uzelf of in opdracht van u direct aan een andere partij.
        Wij kunnen u vragen om u te legitimeren voordat wij gehoor kunnen geven aan voornoemde verzoeken.
        </p>
    </section>

    <section>
        <h3>Klachten</h3>
        <p>
        Mocht u een klacht hebben over de verwerking van uw persoonsgegevens dan vragen wij u hierover direct contact met ons op te nemen.
        U heeft altijd het recht een klacht in te dienen bij de Privacy Commissie, dit is de toezichthoudende autoriteit op het gebied van privacy bescherming.
        </p>
    </section>

    <section>
        <h3>Wijziging privacy statement</h3>
        <p>
        vzw K.F. "De Moedige Vrienden" kan zijn privacy statement wijzigen.
        Van deze wijziging zullen we een aankondiging doen op onze website.
        De laatste wijziging gebeurde op 10 september 2023
        </p>
        <p>
        Oudere versies van ons privacy statement zullen in ons archief worden opgeslagen.
        Stuur ons een e-mail als u deze wilt raadplegen.
        </p>
    </section>
    </main>
  );
};

export default Privacy;
